export const Sort = ['Newer first', 'Older first', 'A-Z', 'Z-A'];
export const SortMap = {
  'Newer first': 'releaseDate,DESC',
  'Older first': 'releaseDate,ASC',
  'A-Z': 'name,ASC',
  'Z-A': 'name,DESC',
};
